import { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Row, Col, OverlayTrigger, Tooltip } from 'react-bootstrap'
import moment from 'moment/min/moment-with-locales';

//components
import withLocalization from '~/hoc/withLocalization';
import WagetypeRefetch from '../WagetypeRefetch.js';
import TableWidget from '../TableWidget.js';

//elements
import { NumberInput } from '../../../../elements/Input.js';
import Select from '../../../../elements/Select.js';
import SwitchWidget from '../SwitchWidget.js';
import DatePicker from '../../../../components/DatePicker/DatePicker.jsx';

//utils
import { payrollIntegrationOptions } from '../../../../utils/constants.js';

const cycle_options = [
    { value: 'half_yearly', label: "Half Yearly", title: "Half Yearly" },
    { value: 'yearly', label: "Yearly", title: "Yearly" }
]

const choose_on_expiry_options = [
    { value: 'CARRY_FORWARD_TO_NEXT_CYCLE', label: "Carry forward to next cycle", title: "Carry forward to next cycle" }
]

const getState = {
    allowManualSyncingForAutomaticFlexitime: false,
    allowAutoSendHoursToCompOff: false,
    allowAutomaticFlexitimeTimeBank: false,
    allowNegativeTimeAccumulation: false,
    allowPaidAbsenceHoursToCalculateFlexitime: false,
    allowOnlyScheduleBasedShiftsToCalculateFlexitime: false,
    switchOnFlexitimeForAllUsers: false,
    sendFullHoursToPayroll: false,
    allowAutoOvertimeToTimebank: false,
}



class TimeBankSettings extends Component {
    constructor(props) {
        super(props);
        this.state = {
            timeBankSettings: {
                allowTimeBank: false,
                ...getState,
                cycle: 'yearly',
                cycleStartDate: null,
                cycleEndDate: null,
                maxHourLimitInCycle: 0,
                maxMinuteLimitInCycle: 0,
                onCycleExpiry: 0,
                maxNegativeFlexitimeLimit: 0,
                maxPositiveFlexitimeLimit: 0,
                timeBankWageTypes: props.commonStore?.config?.integration_details?.product ? [
                    { code: 'payout', name: 'Payout', filter: 'at' },
                    { code: 'compansatory_off', name: 'Compansatory Off', filter: 'ab' },
                    { code: 'flexitime+', name: 'Flexitime+', filter: props.commonStore?.config?.integration_details?.product === payrollIntegrationOptions.TRIPLETEX ? 'ab' : props.commonStore?.config?.integration_details?.product === payrollIntegrationOptions.XLEDGER ? 'su' : 'at' },
                    { code: 'flexitime-', name: 'Flexitime-', filter: 'ab' }
                ] : [],
            },
            // absenceCode: props.commonStore.getWageTypesAccordingToIntegrations(props.commonStore?.config?.integration_details, 'absenceCode') || [],
            lastUpdated: props.commonStore.getWageTypesAccordingToIntegrations(props.commonStore?.config?.integration_details, 'last_updated') || null,
            isLoadingWageTypes: false
        }
        this.translateLabels = this.translateLabels.bind(this);

    }

    componentDidMount() {
        this.loadData();
    }

    loadData = () => {
        const { currentEntity } = this.props.clientStore;
        const { timeBankSettings } = this.state;
        if (currentEntity.client?.data?.basicRules?.timeBankSettings) {
            const _timeBankSettings = Object.assign({}, currentEntity.client.data.basicRules?.timeBankSettings);
            timeBankSettings.allowTimeBank = _timeBankSettings.allowTimeBank ? _timeBankSettings.allowTimeBank : false;
            timeBankSettings.allowAutomaticFlexitimeTimeBank = _timeBankSettings.allowAutomaticFlexitimeTimeBank ? _timeBankSettings.allowAutomaticFlexitimeTimeBank : false;
            timeBankSettings.allowManualSyncingForAutomaticFlexitime = _timeBankSettings.allowManualSyncingForAutomaticFlexitime ? _timeBankSettings.allowManualSyncingForAutomaticFlexitime : false;
            timeBankSettings.allowAutoSendHoursToCompOff = _timeBankSettings.allowAutoSendHoursToCompOff ? _timeBankSettings.allowAutoSendHoursToCompOff : false;
            timeBankSettings.allowPaidAbsenceHoursToCalculateFlexitime = _timeBankSettings.allowPaidAbsenceHoursToCalculateFlexitime ? _timeBankSettings.allowPaidAbsenceHoursToCalculateFlexitime : false;
            timeBankSettings.allowOnlyScheduleBasedShiftsToCalculateFlexitime = _timeBankSettings.allowOnlyScheduleBasedShiftsToCalculateFlexitime ? _timeBankSettings.allowOnlyScheduleBasedShiftsToCalculateFlexitime : false;
            timeBankSettings.switchOnFlexitimeForAllUsers = _timeBankSettings.switchOnFlexitimeForAllUsers ? _timeBankSettings.switchOnFlexitimeForAllUsers : false;
            timeBankSettings.cycle = _timeBankSettings.cycle ? _timeBankSettings.cycle : 'yearly';
            timeBankSettings.cycleStartDate = _timeBankSettings.cycleStartDate ? _timeBankSettings.cycleStartDate : false;
            timeBankSettings.cycleEndDate = _timeBankSettings.cycleEndDate ? _timeBankSettings.cycleEndDate : false;
            timeBankSettings.maxHourLimitInCycle = _timeBankSettings.maxHourLimitInCycle ? _timeBankSettings.maxHourLimitInCycle : 0;
            timeBankSettings.maxPositiveFlexitimeLimit = _timeBankSettings.maxPositiveFlexitimeLimit ? _timeBankSettings.maxPositiveFlexitimeLimit : 0;
            timeBankSettings.maxNegativeFlexitimeLimit = _timeBankSettings.maxNegativeFlexitimeLimit ? _timeBankSettings.maxNegativeFlexitimeLimit : 0;
            timeBankSettings.maxMinuteLimitInCycle = _timeBankSettings.maxMinuteLimitInCycle ? _timeBankSettings.maxMinuteLimitInCycle : 0;
            timeBankSettings.allowNegativeTimeAccumulation = _timeBankSettings.allowNegativeTimeAccumulation ? _timeBankSettings.allowNegativeTimeAccumulation : false;
            timeBankSettings.sendFullHoursToPayroll = _timeBankSettings.sendFullHoursToPayroll ? _timeBankSettings.sendFullHoursToPayroll : false;
            timeBankSettings.allowAutoOvertimeToTimebank = _timeBankSettings.allowAutoOvertimeToTimebank ? _timeBankSettings.allowAutoOvertimeToTimebank : false;
            timeBankSettings.onCycleExpiry = _timeBankSettings.onCycleExpiry ? _timeBankSettings.onCycleExpiry : 'LOG_HOURS_INTO_TIMESHEET';
            if (_timeBankSettings.timeBankWageTypes?.length) {
                const defaultWageTypesMap = new Map(timeBankSettings.timeBankWageTypes.map(wt => [wt.code, wt]));
                const updatedWageTypes = _timeBankSettings.timeBankWageTypes.map(wt => {
                    const defaultWt = defaultWageTypesMap.get(wt.code);
                    if (defaultWt && wt.filter !== defaultWt.filter)
                        return { ...wt, filter: defaultWt.filter };
                    return wt;
                });
                timeBankSettings.timeBankWageTypes = updatedWageTypes;
            } else {
                timeBankSettings.timeBankWageTypes = [...timeBankSettings.timeBankWageTypes];
            }
        }
        this.prepareCycleDate(timeBankSettings.cycle, timeBankSettings)
        this.setState({ timeBankSettings });
    }

    prepareCycleDate = (evt, timeBankSettings) => {
        switch (evt) {
            case 'yearly':
                timeBankSettings['cycleStartDate'] = moment(new Date()).startOf('year').format('YYYY-MM-DD')
                timeBankSettings['cycleEndDate'] = moment(new Date()).endOf('year').format('YYYY-MM-DD')
                break;
            case 'half_yearly':
                const currentMonth = moment().month();
                if (currentMonth < 6) {
                    timeBankSettings['cycleStartDate'] = moment(new Date()).startOf('year').format('YYYY-MM-DD');
                    timeBankSettings['cycleEndDate'] = moment(new Date()).month(5).endOf('month').format('YYYY-MM-DD');
                } else {
                    timeBankSettings['cycleStartDate'] = moment(new Date()).month(7).startOf('month').format('YYYY-MM-DD');
                    timeBankSettings['cycleEndDate'] = moment(new Date()).endOf('year').format('YYYY-MM-DD');
                }
                break;
            default:
                console.info("No event found")
        }
    }

    validateFeilds = (name, value) => {
        if (name === 'maxHourLimitInCycle') {
            if ((value).toString().length > 3)
                return 'Max hours Limit is 999 hours';
        }
        if (name === 'maxMinuteLimitInCycle') {
            if (value > 60)
                return 'Max minute Limit is 59 minute';
        }
        if (name === 'maxNegativeFlexitimeLimit') {
            if (value > 0)
                return 'Max Negative Flexitime Can only be 0 or negative value';
        }
        if (name === 'maxPositiveFlexitimeLimit') {
            if (value < 0)
                return 'Max Positive Flexitime Can only be 0 or positive value';
        }
    }

    handleCheck = (name, evt) => {
        const { commonStore, t } = this.props;
        const { timeBankSettings: _timeBankSettings } = this.state;
        let timeBankSettings = _timeBankSettings;
        const isNotValid = this.validateFeilds(name, evt);

        if (name === 'allowTimeBank' && !evt) {
            timeBankSettings = { ...timeBankSettings, ...getState, allowTimeBank: false };
        }

        if (isNotValid)
            return commonStore.addNotification(t(isNotValid), null, 'error');
        if (name === 'cycle')
            this.prepareCycleDate(evt, timeBankSettings);
        if (name === 'allowManualSyncingForAutomaticFlexitime') {
            timeBankSettings.allowManualSyncingForAutomaticFlexitime = !!evt;
            if (!evt) {
                timeBankSettings.allowAutoSendHoursToCompOff = false;
            }
        } else if (name === 'allowAutoSendHoursToCompOff') {
            timeBankSettings.allowAutoSendHoursToCompOff = !!evt;
            if (evt) {
                timeBankSettings.allowManualSyncingForAutomaticFlexitime = true;
            }
        }
        else if (name === 'switchOnFlexitimeForAllUsers') {
            if (evt)
                commonStore.addNotification(t("Flexitime will be enabled for all users by default. However, you can still override it in individual user profiles"), null, 'warning', null, 2000);
            else
                commonStore.addNotification(t("Flexitime will be disabled for all users by default. However, you can still override it in individual user profiles"), null, 'warning', null, 2000);
            timeBankSettings[name] = evt;
        }
        else {
            timeBankSettings[name] = evt;
        }
        this.props.handleUserDataChange('timeBankSettings', timeBankSettings);
        this.setState({ timeBankSettings });
    }

    handleTimeBankWageTypes = (data) => {
        this.handleCheck('timeBankWageTypes', data)
    }


    refetchWageType = async () => {
        const { commonStore, t } = this.props;
        try {
            await commonStore.refetchWagetypes();
            commonStore.addNotification(t('Successfully refetched wagetypes'), null, 'success');
            const _lastUpdated = commonStore.getWageTypesAccordingToIntegrations(commonStore?.config?.integration_details, 'last_updated') || null;
            // const _absenceCode = commonStore.getWageTypesAccordingToIntegrations(commonStore?.config?.integration_details, 'absenceCode') || [];
            this.setState({ lastUpdated: _lastUpdated, isLoadingWageTypes: false });

        } catch (err) {
            console.error(err);
            commonStore.addNotification(t('Something went wrong'), null, 'error');
            this.setState({ isLoadingWageTypes: false });
        }
    }

    translateLabels = () => {
        const { t } = this.props;
        cycle_options.forEach(item => {
            item.label = t(item.title)
        });
        choose_on_expiry_options.forEach(item => {
            item.label = t(item.title)
        });
    }

    render() {
        const { timeBankSettings, lastUpdated, isLoadingWageTypes } = this.state;
        const { t, commonStore, clientStore } = this.props;
        const isAutoSchedule = clientStore.currentEntity?.client?.data?.loginRules?.autoTimelogs === 'autoschedule';
        let headers = ['Name', 'Wage Type']
        let metaData = [
            { field: 'name', type: 'text', placeholder: 'name', required: true, unique: true },
            { field: 'payrollWageType', type: 'select', placeholder: 'Select...', unique: true, select: true, data: filter => commonStore.getWageTypesAccordingToIntegrations(commonStore?.config?.integration_details, filter) }
        ]
        // if (this.props.commonStore?.config?.integration_details?.product === payrollIntegrationOptions.XLEDGER) {
        //     headers.splice(2, 0, 'Absence Code');
        //     metaData.splice(2, 0, { field: 'absenceCode', type: 'select', placeholder: 'Absence Code', select: true, data: (filter) => filter === 'ab' ? absenceCode : [] });
        // }

        this.translateLabels();
        return (
            <div className='w-100'>
                <Row className='mb-3'>
                    <label className="control-label font-size-15 font-color-primary">{t('Basic')}</label>
                </Row>
                <Row>
                    <Col sm={1} className='mt-1'>
                        <SwitchWidget
                            value={timeBankSettings.allowTimeBank}
                            onChange={checked => this.handleCheck('allowTimeBank', checked)}
                        />
                    </Col>
                    <Col sm={5} className='d-flex'>
                        <div>
                            <label className="control-label">{t('Allow Time Bank')}</label>
                            <i className='fs12 d-block'>{timeBankSettings.allowAutomaticFlexitimeTimeBank ? (`${t('Overtime')}/${t('Flexitime')} → ${t('Timebank')}`) : (`${t('Overtime')} → ${t('Timebank')}`)}</i>
                        </div>
                        <div className='ml-30'>
                            <OverlayTrigger
                                key="allowTimeBank"
                                placement="right"
                                overlay={
                                    <Tooltip id="tooltip-top">
                                        {t("Enabling this will give access to use Time Bank feature")}
                                    </Tooltip>
                                }>
                                <i className="fa fa-info-circle text-muted" style={{ opacity: '0.5' }} aria-hidden="true"></i>
                            </OverlayTrigger>
                        </div>
                    </Col>
                </Row>
                <hr />
                <Row className='mb-3'>
                    <label className="control-label font-size-15 font-color-primary">{t('Flexitime settings')}</label>
                </Row>
                <Row className='mt-2'>
                    {commonStore?.config?.client?.allow_company_shifts &&
                        <>
                            <Col sm={1}>
                                <SwitchWidget
                                    value={timeBankSettings.allowAutomaticFlexitimeTimeBank}
                                    onChange={checked => this.handleCheck('allowAutomaticFlexitimeTimeBank', checked)}
                                />
                            </Col>
                            <Col sm={7} className='d-flex'>
                                <label className="control-label">{t('Allow Automatic Flexitime Time Bank')}</label>
                                <div className='ml-30'>
                                    <OverlayTrigger
                                        key="allowTimeBank"
                                        placement="left"
                                        overlay={
                                            <Tooltip id="tooltip-top">
                                                {t("Enabling this will calculate the flextime automatic according to shift time and log hours into timebank directly")}
                                            </Tooltip>
                                        }>
                                        <i className="fa fa-info-circle text-muted" style={{ opacity: '0.5' }} aria-hidden="true"></i>
                                    </OverlayTrigger>
                                </div>
                            </Col>
                        </>
                    }
                </Row>
                <Row className='mt-2'>
                    {timeBankSettings.allowAutomaticFlexitimeTimeBank && commonStore?.config?.client?.allow_company_shifts &&
                        <>
                            <Col sm={1}>
                                <SwitchWidget
                                    value={timeBankSettings.switchOnFlexitimeForAllUsers}
                                    onChange={checked => this.handleCheck('switchOnFlexitimeForAllUsers', checked)}
                                />
                            </Col>
                            <Col sm={5} className='d-flex'>
                                <label className="control-label">{t('Switch on flexitime for all users')}</label>
                                <div className='ml-30'>
                                    <OverlayTrigger
                                        key="allowTimeBank"
                                        placement="left"
                                        overlay={
                                            <Tooltip id="tooltip-top">
                                                {t("Enabling this feature will on flexitime for all users")}
                                            </Tooltip>
                                        }>
                                        <i className="fa fa-info-circle text-muted" style={{ opacity: '0.5' }} aria-hidden="true"></i>
                                    </OverlayTrigger>
                                </div>
                            </Col>
                        </>
                    }
                    <Col sm={1}>
                        <SwitchWidget
                            value={timeBankSettings.sendFullHoursToPayroll}
                            onChange={checked => this.handleCheck('sendFullHoursToPayroll', checked)}
                        />
                    </Col>
                    <Col sm={5} className='d-flex'>
                        <label className="control-label">{t('Send all the hours to payroll')}</label>
                        <div className='ml-30'>
                            <OverlayTrigger
                                key="allowTimeBank"
                                placement="left"
                                overlay={
                                    <Tooltip id="tooltip-top">
                                        {t("Enabling this feature will send all hours to payroll instead of deducting the timebank hours (Normal Flexitime)")}
                                    </Tooltip>
                                }>
                                <i className="fa fa-info-circle text-muted" style={{ opacity: '0.5' }} aria-hidden="true"></i>
                            </OverlayTrigger>
                        </div>
                    </Col>
                </Row>
                <Row className='mt-2'>
                    {timeBankSettings.allowAutomaticFlexitimeTimeBank && commonStore?.config?.client?.allow_company_shifts &&
                        <>
                            <Col sm={1}>
                                <SwitchWidget
                                    value={timeBankSettings.allowOnlyScheduleBasedShiftsToCalculateFlexitime}
                                    onChange={checked => this.handleCheck('allowOnlyScheduleBasedShiftsToCalculateFlexitime', checked)}
                                />
                            </Col>
                            <Col sm={5} className='d-flex'>
                                <label className="control-label">{t('Allow only scheduled-shifts to calculate flexitime')}</label>
                                <div className='ml-10'>
                                    <OverlayTrigger
                                        key="allowTimeBank"
                                        placement="left"
                                        overlay={
                                            <Tooltip id="tooltip-top">
                                                {t("Enabling this feature will take only shifts which are schedule-based into consideration for flexitime calculation")}
                                            </Tooltip>
                                        }>
                                        <i className="fa fa-info-circle text-muted" style={{ opacity: '0.5' }} aria-hidden="true"></i>
                                    </OverlayTrigger>
                                </div>
                            </Col>
                        </>
                    }
                    <Col sm={1}>
                        <SwitchWidget
                            value={timeBankSettings.allowPaidAbsenceHoursToCalculateFlexitime}
                            onChange={checked => this.handleCheck('allowPaidAbsenceHoursToCalculateFlexitime', checked)}
                        />
                    </Col>
                    <Col sm={5} className='d-flex'>
                        <label className="control-label">{t('Allow absence hours to calculate flexitime')}</label>
                        <div className='ml-30'>
                            <OverlayTrigger
                                key="allowTimeBank"
                                placement="left"
                                overlay={
                                    <Tooltip id="tooltip-top">
                                        <div style={{ textAlign: 'left' }}>
                                            {t("Enabling this feature will take paid absence hours into consideration for flexitime calculation")}
                                            <div className="mt-1"><b>{t('Note')}:</b></div>
                                            {
                                                <div><b>-</b> {t('Absence hours will be considered for single day absence only')}</div>
                                            }
                                            {isAutoSchedule &&
                                                <div><b>-</b> {t('Absence hours will not be considered for auto recorded timesheets')}</div>
                                            }
                                        </div>
                                    </Tooltip>
                                }>
                                <i className="fa fa-info-circle text-muted" style={{ opacity: '0.5' }} aria-hidden="true"></i>
                            </OverlayTrigger>
                        </div>
                    </Col>
                </Row>

                {timeBankSettings.allowAutomaticFlexitimeTimeBank &&
                    <>
                        <Row className={'my-2 w-100'}>
                            <Col xs={6}>
                                <label className="control-label">{t('Max negative flexitime limit for all users')}</label>
                                <NumberInput
                                    width={"50"}
                                    value={timeBankSettings.maxNegativeFlexitimeLimit}
                                    onChange={e => {
                                        this.handleCheck('maxNegativeFlexitimeLimit', e.target.value);
                                    }}
                                />
                                <i className='fs12 d-block'>{t('If limit is set 0 then there will be no limit for flexitime')}.</i>
                            </Col>
                            <Col xs={6}>
                                <label className="control-label">{t('Max positive flexitime limit for all users')}</label>
                                <NumberInput
                                    width={"50"}
                                    value={timeBankSettings.maxPositiveFlexitimeLimit}
                                    onChange={e => {
                                        this.handleCheck('maxPositiveFlexitimeLimit', e.target.value);
                                    }}
                                />
                                <i className='fs12 d-block'>{t('If limit is set 0 then there will be no limit for flexitime')}.</i>
                            </Col>
                        </Row>
                        <hr />
                    </>
                }
                <Row className='mt-3'>
                    <label className="control-label font-size-15 font-color-primary">{t('Overtime settings')}</label>
                </Row>
                <Row className='mt-2 mb-3'>
                    {commonStore?.config?.client?.allow_company_shifts &&
                        <>
                            <Col sm={1} className='mt-1'>
                                <SwitchWidget
                                    value={timeBankSettings.allowAutoOvertimeToTimebank}
                                    onChange={checked => this.handleCheck('allowAutoOvertimeToTimebank', checked)}
                                />
                            </Col>
                            <Col sm={5} className='d-flex'>
                                <div>
                                    <label className="control-label">{t('Automatically add overtime to timebank')}</label>
                                </div>
                                <div className='ml-30'>
                                    <OverlayTrigger
                                        key="allowTimeBank"
                                        placement="left"
                                        overlay={
                                            <Tooltip id="tooltip-top">
                                                {t("Enabling this feature will automatically add overtime hours to the timebank")}
                                            </Tooltip>
                                        }>
                                        <i className="fa fa-info-circle text-muted" style={{ opacity: '0.5' }} aria-hidden="true"></i>
                                    </OverlayTrigger>
                                </div>
                            </Col>
                        </>
                    }
                </Row>
                <hr />
                {timeBankSettings.allowAutomaticFlexitimeTimeBank &&
                    <>
                        <Row className='mt-3'>
                            <label className="control-label font-size-15 font-color-primary">{t('Hours forward settings')}</label>
                        </Row>
                        <Row className='mt-2 mb-3'>
                            {timeBankSettings.allowAutomaticFlexitimeTimeBank && commonStore?.config?.client?.allow_company_shifts &&
                                <>
                                    <Col sm={1} className='mt-1'>
                                        <SwitchWidget
                                            value={timeBankSettings.allowAutoSendHoursToCompOff}
                                            onChange={checked => this.handleCheck('allowAutoSendHoursToCompOff', checked)}
                                        />
                                    </Col>
                                    <Col sm={5} className='d-flex'>
                                        <div>
                                            <label className="control-label">{t('Automatically send hours to comp-off')}</label>
                                            <i className='fs12 d-block'>{(`${t('Flexitime')} → ${t('Timebank')} → ${t('Comp-off')} ${t('Balance')}`)}</i>
                                        </div>
                                        <div className='ml-30'>
                                            <OverlayTrigger
                                                key="allowTimeBank"
                                                placement="left"
                                                overlay={
                                                    <Tooltip id="tooltip-top">
                                                        {t("Enabling this feature will allow you send hours in comp off balance")}
                                                    </Tooltip>
                                                }>
                                                <i className="fa fa-info-circle text-muted" style={{ opacity: '0.5' }} aria-hidden="true"></i>
                                            </OverlayTrigger>
                                        </div>
                                    </Col>
                                </>
                            }
                            {timeBankSettings.allowAutomaticFlexitimeTimeBank && commonStore?.config?.client?.allow_company_shifts &&
                                <>
                                    <Col sm={1} className='mt-1'>
                                        <SwitchWidget
                                            value={timeBankSettings.allowManualSyncingForAutomaticFlexitime}
                                            onChange={checked => this.handleCheck('allowManualSyncingForAutomaticFlexitime', checked)}
                                        />
                                    </Col>
                                    <Col sm={5} className='d-flex'>
                                        <div>
                                            <label className="control-label">{t('Manually save hours to payroll system')}</label>
                                            <i className='fs12 d-block'>{(`${t('Flexitime')} → ${t('Timebank')} → ${t('Payroll')}`)}</i>
                                        </div>
                                        <div className='ml-30'>
                                            <OverlayTrigger
                                                key="allowTimeBank"
                                                placement="left"
                                                overlay={
                                                    <Tooltip id="tooltip-top">
                                                        {t("Enabling this feature will allow you sync hours manually in payroll system")}
                                                    </Tooltip>
                                                }>
                                                <i className="fa fa-info-circle text-muted" style={{ opacity: '0.5' }} aria-hidden="true"></i>
                                            </OverlayTrigger>
                                        </div>
                                    </Col>
                                </>
                            }
                        </Row>
                        <hr />
                    </>
                }
                <Row className='mb-3'>
                    <label className="control-label font-size-15 font-color-primary">{t('Cyclic settings')}</label>
                </Row>
                <Row className={'mt-2'}>
                    <Col sm={4}>
                        <label className="control-label">{t('Cycle')}</label>
                        <Select
                            options={cycle_options}
                            value={cycle_options.find(item => item.value === timeBankSettings.cycle)}
                            onChange={evt => {
                                this.handleCheck('cycle', evt.value)
                            }}
                            style={{ width: '100%' }}
                        />
                    </Col>
                    <Col sm={8}>
                        <label className="control-label">{t('Cycle Start And End Details')}</label>
                        <Row>
                            <Col xs={12} sm={6}>
                                <DatePicker
                                    selected={new Date(timeBankSettings.cycleStartDate)}
                                    placeholder={'From'}
                                    dateFormat="dd-MM-yyyy"
                                    disabled={true}
                                />
                            </Col>
                            <Col xs={12} sm={6} className="mt-sm-0 mt-2">
                                <DatePicker
                                    selected={new Date(timeBankSettings.cycleEndDate)}
                                    placeholder={'To'}
                                    dateFormat="dd-MM-yyyy"
                                    disabled={true}

                                />
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row className={'my-4 w-100'}>
                    <Col xs={6}>
                        <label className="control-label">{t('Max Hours Limit For Individually In a Cycle')}
                            <span className="text-muted "><em> (hhh)</em></span>
                        </label>
                        <NumberInput
                            width={"50"}
                            value={timeBankSettings.maxHourLimitInCycle}
                            onChange={e => {
                                this.handleCheck('maxHourLimitInCycle', e.target.value);
                            }}
                        />
                    </Col>
                    <Col xs={6}>
                        <label className="control-label">{t('Max Minutes Limit For Individually In a Cycle')}
                            <span className="text-muted "><em> (mm)</em></span>
                        </label>
                        <NumberInput
                            width={"50"}
                            value={timeBankSettings.maxMinuteLimitInCycle}
                            onChange={e => {
                                this.handleCheck('maxMinuteLimitInCycle', e.target.value);
                            }}
                        />
                    </Col>
                </Row>
                <Row className='mb-2'>
                    <Col sm={6}>
                        <label className="control-label">{t('Choose what happen on expiry')}</label>
                        <Select
                            options={choose_on_expiry_options}
                            value={choose_on_expiry_options.find(item => item.value === timeBankSettings.onCycleExpiry)}
                            onChange={evt => {
                                this.handleCheck('onCycleExpiry', evt.value)
                            }}
                            style={{ width: '100%' }}
                        />
                    </Col>
                </Row>
                {!!(commonStore?.config?.integration_details?.product) &&
                    <>
                        {!!timeBankSettings.timeBankWageTypes &&
                            <WagetypeRefetch
                                t={this.props.t}
                                refetch={() => this.setState({ isLoadingWageTypes: true }, this.refetchWageType)}
                                lastUpdated={lastUpdated}
                                isLoading={isLoadingWageTypes}
                                dateTimeRules={this.props.commonStore.getDateTimeRules()}
                            />
                        }

                        <TableWidget
                            headers={headers}
                            metaData={metaData}
                            data={timeBankSettings.timeBankWageTypes}
                            onChange={data => this.handleTimeBankWageTypes(data)}
                            page={"timeBank"}
                            minRemoveIndex={3}
                            className='mb-100'
                        />
                    </>
                }
            </div>
        );
    }
}

export default withLocalization(inject('clientStore', 'commonStore')(observer(TimeBankSettings)));
